export default __webpack_public_path__ + "static/HalvarBreit-Md-7b453df9390397a98e8f26c7b193da91.woff2";